import { AnalyticsBrowser } from '@segment/analytics-next';
import { AnalyticsPluginType } from '.';

declare global {
  interface Window {
    segment: any;
  }
}

class SegmentAnalyticsPlugin implements AnalyticsPluginType {
  private initialized: boolean = false;

  constructor(segmentWriteKey: string) {
    if (!window.segment) {
      window.segment = AnalyticsBrowser.load({ writeKey: segmentWriteKey });
      this.initialized = true;
    }
  }

  identifyUser(
    userId: string,
    userProperties: Record<string, string | number>
  ): void {
    window.segment.identify(userId, userProperties);
  }

  resetUser(): void {
    window.segment.reset();
  }

  trackEvent(category: string, action: string): void {
    window.segment.track(action, {
      category,
    });
  }

  trackPageView(path?: string): void {
    window.segment.page(path);
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}

export default SegmentAnalyticsPlugin;
